import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "entity-links" }
const _hoisted_2 = { class: "link-kind" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "link-create" }
const _hoisted_5 = { class: "entity-search" }
const _hoisted_6 = {
  key: 0,
  class: "entity-results"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.links, (link) => {
      return (_openBlock(), _createElementBlock("div", {
        key: link.id,
        class: "entity-link-row"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString($setup.relation(link)), 1 /* TEXT */),
        _createVNode(_component_RouterLink, {
          to: $setup.path(link.entity)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.entity.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
        _createElementVNode("small", null, _toDisplayString(link.entity.subtitle), 1 /* TEXT */),
        _createElementVNode("button", {
          type: "button",
          title: "Удалить связь",
          onClick: $event => ($setup.removeLink(link.id))
        }, "×", 8 /* PROPS */, _hoisted_3)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.kind) = $event))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("option", { value: "related" }, "Связана с", -1 /* CACHED */),
        _createElementVNode("option", { value: "blocks" }, "Блокирует", -1 /* CACHED */)
      ]))], 512 /* NEED_PATCH */), [
        [_vModelSelect, $setup.kind]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.query) = $event)),
          placeholder: "Найти партнёра или задачу",
          onInput: $setup.search
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelText, $setup.query]
        ]),
        ($setup.results.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.results, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: `${item.type}-${item.id}`,
                  type: "button",
                  onClick: $event => {$setup.selected=item; $setup.query=item.title; $setup.results=[]}
                }, [
                  _createElementVNode("strong", null, _toDisplayString(item.title), 1 /* TEXT */),
                  _createElementVNode("small", null, _toDisplayString(item.subtitle), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        disabled: !$setup.selected || $setup.searching,
        onClick: $setup.createLink
      }, "Связать", 8 /* PROPS */, _hoisted_8)
    ])
  ]))
}